export const enum OpenReportEvent {
  IframeLoaded = 'IframeLoaded',
  ClientInit = 'ClientInit',
}
